if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.compteurLie = false;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      get mobile() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      get conteneur() {
        return this.querySelector('[role="document"]');
      }

      // Uniquement les enfants directs : le modele 3D porte lui aussi un
      // data-media-id sur un noeud interne, on ne veut pas le compter deux fois.
      get medias() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      showActiveMedia() {
        const cible = this.openedBy.getAttribute('data-media-id');
        const medias = this.medias;

        medias.forEach((element) => {
          element.classList.toggle('active', element.getAttribute('data-media-id') === cible);
        });

        const activeMedia = medias.find((el) => el.getAttribute('data-media-id') === cible) || medias[0];
        if (!activeMedia) return;

        const conteneur = this.conteneur;

        if (this.mobile) {
          // Carrousel horizontal : chaque media fait exactement une largeur
          // d'ecran, donc l'index suffit a se positionner. Pas d'animation :
          // on doit deja etre sur la bonne photo a l'ouverture.
          const index = medias.indexOf(activeMedia);
          this.preparerCompteur();
          const caler = () => {
            conteneur.scrollTo({ left: index * conteneur.clientWidth, behavior: 'auto' });
            this.majCompteur();
          };
          caler();
          // les images sont en chargement differe : on recale apres le rendu
          requestAnimationFrame(caler);
        } else {
          activeMedia.scrollIntoView();
        }

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      preparerCompteur() {
        if (this.medias.length < 2) return;

        if (!this.compteur) {
          this.compteur = document.createElement('p');
          this.compteur.className = 'product-media-modal__compteur';
          this.compteur.setAttribute('aria-hidden', 'true');
          this.querySelector('.product-media-modal__dialog').appendChild(this.compteur);
        }

        if (!this.compteurLie) {
          this.conteneur.addEventListener(
            'scroll',
            () => {
              clearTimeout(this.tempo);
              this.tempo = setTimeout(() => this.majCompteur(), 60);
            },
            { passive: true }
          );
          this.compteurLie = true;
        }
      }

      majCompteur() {
        if (!this.compteur) return;
        const medias = this.medias;
        const largeur = this.conteneur.clientWidth || 1;
        const index = Math.min(medias.length - 1, Math.max(0, Math.round(this.conteneur.scrollLeft / largeur)));
        this.compteur.textContent = index + 1 + ' / ' + medias.length;
      }
    }
  );
}
